import React from "react";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";

const handleRenderOption = (option, { inputValue }) => {
  let nombre = option?.Titular ?? `${option.Movimiento?.Cuenta?.Nombre.trim()} ${option.Movimiento?.Cuenta?.Apellido_Paterno.trim()}`
  const matches = match(`${option.Movimiento?.Referencia} - ${option.paquete?.Nombre} - ${nombre}`, inputValue);
  const parts = parse(`${option.Movimiento?.Referencia} - ${option.paquete?.Nombre} - ${nombre}`, matches);
  const highlightStyle = {
    fontWeight: 700,
    backgroundColor: "lightyellow",
    padding: "5px 2px",
  };
  return (
    <div>
      {parts.map((part, index) => (
        <span key={index} style={part.highlight ? highlightStyle : {}}>
          {part.text}
        </span>
      ))}
    </div>
  );
};

export default handleRenderOption;
